<template>
  <div id="app">
    <transition name="switch">
      <router-view/>
    </transition>
  </div>
</template>
<script>
export default {
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style>
html, body {
  margin: 0;
  padding: 0;
}
body {
  scrollbar-width: none;
  scrollbar-color: transparent transparent;
}
body::-webkit-scrollbar {
  display: none;
}
:root {
  --maxWidth: 960px;
}
p, ul, li {
  margin: 0;
  padding: 0;
  list-style: none;
}
#app {
  font-family: 'PingFang SC', 'Microsoft Yahei', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  box-sizing: border-box;
  overflow: hidden;
}
.cover-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #000;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  transition: all 0.5s;
}
.mobile-cover-video {
  display: none;
}
.android-icon {
  width: 60px;
  box-sizing: border-box;
  padding: 8px 6px 8px 10px;
  background: #333;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}
.skip {
  width: 60px;
  height: 28px;
  font-size: 14px;
  color: #fff;
  text-align: center;
  line-height: 28px;
  background: rgba(100, 100, 100, 0.6);
  border-radius: 25px;
  cursor: pointer;
  position: fixed;
  right: 20px;
  top: 20px;
  z-index: 1000;
}
.mobile-video-tips {
  display: none;
}
/* 
.switch-enter {
  filter: blur(500px);
}
.switch-leave {
  filter: blur(500px);
} */
.switch-enter-active {
  /* position: absolute; */
  transform-origin: center 200px;
  animation: switch-in 0.5s linear;
}
.switch-leave-active {
  /* position: absolute; */
  /* animation: switch-in 1s ; */
}
@keyframes switch-in {
  /* 0% {
    filter: blur(0px) opacity(100%);
  } */
  0% {
    opacity: 0;
    filter: blur(5px);
    /* transform: scale(1.05); */
  }
  100% {
    opacity: 1;
    filter: blur(0px);
    /* transform: scale(1); */
  }
}
@keyframes show {
  0% {
    opacity: 0;
    transform: translateY(100px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@media screen and (max-width: 750px) {
  /* :root {
    --maxWidth: 7.5rem;
  } */
  body {
    
  }
  .cover-video {
    display: none;
  }
  .mobile-cover-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    background: #000;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    transition: all 0.5s;
    touch-action: none;
  }
  .mobile-video-tips {
    font-size: 14px;
    color: #fff;
    display: block;
    position: fixed;
    z-index: 1000;
    top: 65%;
    left: 50%;
    transform: translateX(-50%);
  }
  .swiper-pagination-bullet {
    width: 25px !important;
    height: 4px !important;
    border-radius: 0 !important;
    background: #4a5144 !important;
    opacity: 1 !important;
    margin: 0 5px;
  }
  .swiper-pagination-bullet-active {
    background: #e50027 !important;
  }
  .content-html img{
    max-width: 100%;
    height: auto !important;
  }
  .content-html video {
    max-width: 100%;
  }
}
</style>
